import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import Radium from "radium";
import Utils from "../../../lib/utils";
import logo from "../../../images/logo.png";
import { styles } from "./style.ts";
import SearchForm from "./SearchForm";
import Links from "./Links";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keywords: "",
      location: "",
    };
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleSubmit = () => {
    const { keywords, location } = this.state;
    document.location = Utils.getSearchUrl(keywords, location);
  };

  render() {
    const { keywords, location } = this.state;
    return (
      <footer style={styles.container}>
        <Grid>
          <Row>
            <Col md={4}>
              <h2 style={styles.h2}>
                <Link to="/">
                  <img src={logo} alt="logo" />
                  &nbsp;
                </Link>
              </h2>
              <h3 style={styles.green}>Find the job that's right for you.</h3>
              <p style={styles.p}>
                Are you looking for a new job? You've found the best way to
                start a job search, find companies who want to interview you,
                and get hired!
              </p>
            </Col>
            <Col md={5}>
              <SearchForm
                keywords={keywords}
                location={location}
                handleSubmit={this.handleSubmit}
                handleChange={this.handleChange}
              />
            </Col>
            <Col md={3}>
              <Links />
            </Col>
          </Row>
          <Row>
            <Col>
              <div style={styles.hr} />
              <div
                style={{ fontSize: 12, textAlign: "center" }}
                className="copyright"
              >
                &copy; 2019-2020 QuirkyCoders. All rights reserved.
              </div>
            </Col>
          </Row>
        </Grid>
      </footer>
    );
  }
}

export default Radium(Footer);
